import { useEffect, useState } from 'react'

import styles from '../FlexGrid.module.scss'

interface IProps {
  defaultX: number
  widthOne: number
  widthTwo: number
  leftOne: number
  topOne: number
  heightOne: number
  itemsSize: number[]
  saveModifiedSettings: (itemsSize: number[]) => void
  onClose: () => void
}

export const DragnDropItems = (props: IProps) => {
  const {
    defaultX,
    widthOne,
    widthTwo,
    leftOne,
    topOne,
    heightOne,
    onClose,
    saveModifiedSettings,
  } = props
  const [itemsSize, setItemsSize] = useState(props.itemsSize)

  useEffect(() => {
    setItemsSize(props.itemsSize)
  }, [props.itemsSize])

  const moveDrangDrops = (moveX: number, widthOne: number, widthTwo: number) => {
    const dragnDropLine = document.getElementById('DragnDropLine')

    if (dragnDropLine) {
      dragnDropLine.style.left = widthOne - moveX + 'px'

      const step = Math.floor((widthOne + widthTwo) / (itemsSize[0] + itemsSize[1]))

      let newSizeOne = Math.round((widthOne - moveX) / step)
      if (newSizeOne === 0) {
        newSizeOne++
      } else if (itemsSize[0] + itemsSize[1] - newSizeOne === 0) {
        newSizeOne--
      }

      if (newSizeOne !== itemsSize[0]) {
        setItemsSize([newSizeOne, itemsSize[0] + itemsSize[1] - newSizeOne])
      }
    }
  }

  return (
    <div
      style={{
        width: 2 + widthOne + widthTwo,
        left: leftOne,
        top: topOne,
        height: heightOne,
      }}
      className={styles.dropFlex}
      onMouseMove={(e) => moveDrangDrops(defaultX - e.pageX, widthOne, widthTwo)}
      onMouseLeave={() => onClose()}
      onMouseUp={() => {
        saveModifiedSettings(itemsSize)
      }}
    >
      <div
        className={styles.dropFlexLine}
        id={'DragnDropLine'}
        style={{
          left: widthOne,
        }}
      />

      <div
        className={styles.dropFlexCreate}
        style={{
          width: Math.round(((widthOne + widthTwo) / (itemsSize[0] + itemsSize[1])) * itemsSize[0]),
          height: heightOne,
        }}
      >
        <div className={styles.dropFlexCreateBorder} />
      </div>
      <div
        className={styles.dropFlexCreate}
        style={{
          left: Math.round(((widthOne + widthTwo) / (itemsSize[0] + itemsSize[1])) * itemsSize[0]),
          width: Math.round(((widthOne + widthTwo) / (itemsSize[0] + itemsSize[1])) * itemsSize[1]),
          height: heightOne,
        }}
      >
        <div className={styles.dropFlexCreateBorder} />
      </div>
    </div>
  )
}
